import { http } from "@/http/axios.js";
import axios from "axios";
import { getToken } from "@/utils/auth";
import { showScreenLoading, hideScreenLoading } from "@/http/loading.js";
import { dateFormat } from "@/utils/index.js";

/** 联营合作门店分页 */
export function getJointPartnerStorePageAPI(params) {
  return http({
    url: "/admin/store/joint/page",
    method: "get",
    params,
  });
}

/** 修改服务费率 */
export function editJointPartnerStoreServiceFeeAPI(data) {
  return http({
    url: "/admin/store/joint/service/rate/edit",
    method: "post",
    data,
  });
}

/** 联营合作门店-可选联营配置模板列表（分页：page、pageSize） */
export function getJointCooperationTplListAPI(params) {
  return http({
    url: "/admin/store/joint/tpl/page",
    method: "get",
    params,
  });
}

/** 联营合作门店-保存所选联营配置模板 */
export function saveJointPartnerCooperationTplAPI(data) {
  return http({
    url: "/admin/store/joint/tpl/bind",
    method: "post",
    data,
  });
}

/**
 * 联营门店协议下载
 * @param {number} id - 门店ID
 * @returns {Promise<{agreementUrl: string}>}
 */
export function downloadJointAgreementAPI(id) {
  return http({
    url: "/admin/store/joint/agreement/download",
    method: "post",
    data: { id },
  });
}

/**
 * 联营合作门店-联营订单进件开关（列表「进件状态」列的开关）
 */
export function editJointOrderStatusAPI(data) {
  return http({
    url: "/admin/store/joint/order/status/edit",
    method: "post",
    data,
  });
}

/**
 * 联营合作门店-联营功能访问开关（操作列的「禁用/启用」）
 */
export function editJointAccessStatusAPI(data) {
  return http({
    url: "/admin/store/joint/access/status/edit",
    method: "post",
    data,
  });
}

/** 联营合作门店导出 */
export function exportJointPartnerStoreAPI(data) {
  showScreenLoading();
  return axios({
    method: "post",
    url: "/api/admin/store/joint/export",
    responseType: "blob",
    data,
    headers: {
      Authorization: getToken() || "",
    },
  })
    .then((res) => {
      hideScreenLoading();
      const blob = res.data;
      const url = window.URL.createObjectURL(new Blob([blob]));
      const a = document.createElement("a");
      a.style.display = "none";
      a.href = url;
      const filename = `联营合作门店${dateFormat()}.xlsx`;
      a.setAttribute("download", decodeURIComponent(filename));
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(a.href);
      document.body.removeChild(a);
    })
    .catch(() => {
      hideScreenLoading();
    });
}
